import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FileService } from 'src/app/services/file.service';
import { saveAs } from 'file-saver';
import { HttpResponse } from '@angular/common/http';

@Component({
  selector: 'app-order-success',
  templateUrl: './order-success.component.html',
  styleUrls: ['./order-success.component.less']
})
export class OrderSuccessComponent implements OnInit {
  orderNo:string="";
  constructor(private router: Router,private fileService: FileService,private route:ActivatedRoute) { }

  ngOnInit(): void {
    this.route.queryParams.subscribe(params=>{
      this.orderNo = params['orderNo'];
    })
  }

  goHistory(){
    localStorage.removeItem('isOrderDetailBack');
    const country = localStorage.getItem("country");
    this.router.navigateByUrl(`${country}/order/history`);
  }
  goHistoryDetail(data:string){
    const country = localStorage.getItem("country");
    this.router.navigate([`${country}/order/detail`], { queryParams: { orderNo: data,isOrderSuccess:true } });
  }

  //export
  exportExcel(): void {
    const userId = 1000;
    this.fileService
      .exportToExcel(`/eshop_backend/orderInfo/export?userId=${userId}&orderNo=${this.orderNo}`)
      .subscribe(
        (response: HttpResponse<Blob>) => {
          const contentDisposition = response.headers.get('Content-Disposition');
          let fileName = `${this.orderNo}.xls`;
          if (contentDisposition) {
            fileName = contentDisposition.split('fileName=')[1]?.split(';')[0]?.replace(/"/g, '');
          }
          const blob = new Blob([response.body!], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
          });
          saveAs(blob, decodeURIComponent(fileName));
        },
        (error: any) => {
          console.error('Error exporting Excel:', error);
        }
      );
  }

}
